import { TableColumn } from '../../../components/DataTable/TableColumn';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DateColumn } from '../../../components/DataTable/DateColumn';
import { Order } from '../../../interfaces/Order/Order';
import { Pagination } from '../../../interfaces/Pagination';
import { DataTable } from '../../../components/DataTable/DataTable';
import { CustomerCell } from './CustomerCell';
import { CargoCell } from './CargoCell';
import { PriceColumn } from '../../../components/DataTable/PriceColumn';
import { ProductsCell } from './ProductsCell';

const columns: TableColumn<Order>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'created-at',
    name: 'Sipariş Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'status',
    name: 'Durum',
    accessor: (row) => <TextColumn value={row.statusFormatted} />,
  },
  {
    id: 'customer',
    name: 'Alıcı',
    accessor: (row) => <CustomerCell order={row} />,
  },
  {
    id: 'products',
    name: 'Ürünler',
    accessor: (row) => <ProductsCell order={row} />,
  },
  {
    id: 'cargo',
    name: 'Kargo',
    accessor: (row) => <CargoCell order={row} />,
  },
  {
    id: 'total',
    name: 'Tutar',
    accessor: (row) => <PriceColumn value={row.totalAmount} />,
  },
  {
    id: 'payment-method',
    name: 'Ödeme Yöntemi',
    accessor: (row) => <TextColumn value={row.paymentMethod} />,
  },
];

type OrdersTableProps = {
  orders: Order[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
  selectedOrders?: Order[];
  onSelectionChange?: (newSelectedOrders: Order[]) => void;
};

export const OrdersTable = (props: OrdersTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(order) => window.open(`/sales/orders/${order.id}`, '_blank')}
      selectedRows={props.selectedOrders}
      onSelectionChange={props.onSelectionChange}
    />
  );
};
